
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 11C14.2087 11 16 9.20869 16 7C16 4.79043 14.2087 3 12 3C9.79133 3 8.00003 4.79043 8.00003 7C7.99208 9.20075 9.77103 10.9921 11.9718 11H12Z","stroke":"#262D33","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 21C8.22483 21 5 20.4466 5 18.2309C5 16.0152 8.20404 14 12 14C15.7752 14 19 15.996 19 18.2107C19 20.4255 15.796 21 12 21Z","stroke":"#262D33","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    